<template>
  <v-layout v-if="itemsTotal && numberOfPages > 1" class="my-2" justify-center>
    <v-flex shrink>
      <v-pagination v-model="page" :length="numberOfPages" total-visible="10" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", ["itemsPagination", "itemsTotal"]),
    numberOfPages() {
      return Math.ceil(this.itemsTotal / this.itemsPagination.rowsPerPage);
    },
    page: {
      get() {
        return this.itemsPagination.page;
      },
      set(page) {
        this.setCategoryItemsPagination({ pagination: { page } });
      }
    }
  },
  methods: {
    ...mapActions("featureRules", ["setCategoryItemsPagination"])
  }
};
</script>